import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSpring, animated as a } from 'react-spring';
import homeStyles from './home.module.css';
import PodcastCard from './PodcastCard';
import podcasts from '../../data/podcasts';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import Player from '../player/Player';
import SpringIn from '../player/SpringIn';

function Home() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [showPlayer, setShowPlayer] = useState(false);
  const [selectedPodcast, setSelectedPodcast] = useState(null);

  const fadeIn = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { tension: 120, friction: 20 }
  });

  const filteredPodcasts = podcasts.filter(podcast =>
    podcast.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    podcast.publisher.toLowerCase().includes(searchQuery.toLowerCase()) ||
    podcast.category.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const subscribedPodcasts = podcasts.filter(p =>
    user?.subscriptions?.includes(p.id)
  );

  const handleLogout = () => {
    logout();
    navigate('/onboarding');
  };

  const handlePlayPodcast = (podcast) => {
    setSelectedPodcast(podcast);
    setShowPlayer(true);
  };

  return (
    <a.div style={fadeIn} className={homeStyles.container}>
      <header className={homeStyles.header}>
        <div className={homeStyles.headerContent}>
          <div className={homeStyles.logo}>
            <HeadphonesIcon sx={{ fontSize: 36 }} />
            <h1>PodcastApp</h1>
          </div>

          <div className={homeStyles.searchBar}>
            <SearchIcon className={homeStyles.searchIcon} />
            <input
              type="text"
              placeholder="Search podcasts..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={homeStyles.searchInput}
            />
          </div>

          <div className={homeStyles.userMenu}>
            <AccountCircleIcon sx={{ fontSize: 32 }} />
            <div className={homeStyles.userInfo}>
              <span className={homeStyles.userName}>{user?.name || 'User'}</span>
              <button className={homeStyles.logoutBtn} onClick={handleLogout}>
                <LogoutIcon fontSize="small" /> Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className={homeStyles.main}>
        {subscribedPodcasts.length > 0 && (
          <section className={homeStyles.section}>
            <h2 className={homeStyles.sectionTitle}>Your Subscriptions</h2>
            <div className={homeStyles.podcastGrid}>
              {subscribedPodcasts.map(podcast => (
                <PodcastCard
                  key={podcast.id}
                  podcast={podcast}
                  onPlay={handlePlayPodcast}
                />
              ))}
            </div>
          </section>
        )}

        <section className={homeStyles.section}>
          <h2 className={homeStyles.sectionTitle}>
            {searchQuery ? 'Search Results' : 'Discover Podcasts'}
          </h2>
          <div className={homeStyles.podcastGrid}>
            {filteredPodcasts.map(podcast => (
              <PodcastCard
                key={podcast.id}
                podcast={podcast}
                onPlay={handlePlayPodcast}
              />
            ))}
          </div>
          {filteredPodcasts.length === 0 && (
            <div className={homeStyles.noResults}>
              <p>No podcasts found matching "{searchQuery}"</p>
            </div>
          )}
        </section>
      </main>

      {showPlayer && selectedPodcast && (
        <SpringIn onClose={() => setShowPlayer(false)}>
          <Player podcast={selectedPodcast} onClose={() => setShowPlayer(false)} />
        </SpringIn>
      )}
    </a.div>
  );
}

export default Home;
